__turbopack_context__.v({
  "header": "Seksjon-module__lGkBCa__header",
  "ikon": "Seksjon-module__lGkBCa__ikon",
  "innhold": "Seksjon-module__lGkBCa__innhold",
  "kort": "Seksjon-module__lGkBCa__kort",
  "kunBred": "Seksjon-module__lGkBCa__kunBred",
  "kunSmal": "Seksjon-module__lGkBCa__kunSmal",
});
